"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.promise.finally");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.buildQueue = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _m = require("@mutant-ws/m");

var _fastDeepEqual = _interopRequireDefault(require("fast-deep-equal"));

/**
 * Unique, sequential, promise based queue
 *
 * @example
 * const queue = buildQueue()
 *
 * queue.enqueue(Users.login, {
 *  args:{
 *    body: {email: "lorem@test.com", password: "secret"}
 *  }
 * })
 *   .then(...)
 *   .catch(...)
 *
 * @return {Object<enqueue, dequeue>}
 */
var buildQueue = function buildQueue() {
  var jobsList = [];
  var isProcessing = false;
  return {
    enqueue: function enqueue(_ref) {
      var id = _ref.id,
          fn = _ref.fn,
          _args = _ref.args;
      var runningJob = (0, _m.findWith)({
        id: id,
        args: function args(source) {
          return (0, _fastDeepEqual.default)(source, _args);
        }
      })(jobsList);

      if ((0, _m.is)(runningJob)) {
        return runningJob.fnPromise;
      }

      var deferredResolve = null;
      var deferredReject = null;
      var fnResultPromise = new _promise.default(function (resolve, reject) {
        deferredResolve = resolve;
        deferredReject = reject;
      }); // add job at begining of queue

      jobsList.unshift({
        id: id,
        args: _args,
        fn: fn,
        fnResultPromise: fnResultPromise,
        onResolve: function onResolve(results) {
          deferredResolve(results);
        },
        onReject: function onReject(error) {
          deferredReject(error);
        }
      }); // start processing jobs

      this.dequeue(); // return promise that will be resolved after fn is called and resolved

      return fnResultPromise;
    },
    dequeue: function dequeue() {
      var _this = this;

      var shouldStartRunningJobs = !isProcessing && !(0, _m.isEmpty)(jobsList);

      if (!shouldStartRunningJobs) {
        return undefined;
      }

      var _last = (0, _m.last)(jobsList),
          fn = _last.fn,
          args = _last.args,
          onResolve = _last.onResolve,
          onReject = _last.onReject; // no jobs will be started until current one finishes


      isProcessing = true;
      return _promise.default.resolve().then(function () {
        // Need to remove ourselves before job.fn resolves. If another
        // action of the same signature runs right after it will return this
        // job because job still exists in queue
        jobsList.pop();
        return fn.apply(void 0, (0, _toConsumableArray2.default)(args));
      }).then(onResolve).catch(onReject).finally(function () {
        // process next in queue
        isProcessing = false;

        _this.dequeue();
      });
    }
  };
};

exports.buildQueue = buildQueue;